export default __webpack_public_path__ + "static/media/gasag_xl2.78b03479.png";